module.exports = {
      id: "transport--marker-usage",
      viewBox: "0 0 385 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#transport--marker-usage",
      toString: function () {
        return this.url;
      }
    }